import { Landmark, RefreshCw, Timer, UserCheck } from "lucide-react";

const REASONS = [
  { Icon: Landmark, title: "Government data", text: "Every document comes straight from official government records. No middlemen, no guesswork." },
  { Icon: Timer, title: "Reports in minutes", text: "What took weeks with a lawyer now takes minutes. Get your report before your next visit." },
  { Icon: UserCheck, title: "Real experts", text: "Our legal team checks every difficult case. Fast technology, backed by real people." },
  { Icon: RefreshCw, title: "Always improving", text: "JaaGa learns from every case and gets more accurate with each property." },
];

const HomeWhy = () => (
  <section className="mh-sec" aria-labelledby="mh-why-h">
    <div className="mh-wrap">
      <div className="mh-head">
        <p className="mh-eyebrow">Why JaaGa</p>
        <h2 id="mh-why-h" className="mh-h2">Built on trust and accuracy</h2>
        <p className="mh-lede">
          Buying property is a big decision. We built JaaGa so you never have to make it with missing information.
        </p>
      </div>
      <div className="mh-why4">
        {REASONS.map(({ Icon, title, text }) => (
          <div key={title}>
            <span className="ic">
              <Icon size={21} aria-hidden="true" />
            </span>
            <h3>{title}</h3>
            <p>{text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HomeWhy;
